import React from 'react';
import PropTypes from 'prop-types';
import { Quill } from 'react-quill';

function undoChange() {
	this.quill.history.undo();
}
function redoChange() {
	this.quill.history.redo();
}

const Size = Quill.import('formats/size');
Size.whitelist = ['extra-small', 'small', 'medium', 'large'];
Quill.register(Size, true);

const Font = Quill.import('formats/font');
Font.whitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lucida'];
Quill.register(Font, true);

export const modules = {
	toolbar: {
		container: '#toolbar',
		handlers: {
			undo: undoChange,
			redo: redoChange,
		},
	},
	history: {
		delay: 500,
		maxStack: 100,
		userOnly: true,
	},
};

// Formats objects for setting up the Quill editor
export const formats = [
	'header',
	'font',
	'size',
	'bold',
	'italic',
	'underline',
	'align',
	'strike',
	'script',
	'blockquote',
	'background',
	'list',
	'bullet',
	'indent',
	'link',
	'image',
	'color',
	'code-block',
];

// Quill Toolbar component
export const QuillToolbar = ({ onClickRaw }) => (
	<div id="toolbar">
		<span className="ql-formats">
			<button className="ql-bold" />
			<button className="ql-italic" />
			<button className="ql-underline" />
		</span>
		<span className="ql-formats">
			<button className="ql-list" value="ordered" />
			<button className="ql-list" value="bullet" />
		</span>

		<span className="ql-formats">
			<button className="ql-link" />
		</span>
		<span className="ql-formats">
			<button className="ql-clean" />
		</span>

		<span className="sourcode-btn" onClick={onClickRaw}>
			Kaynak Kod
		</span>
	</div>
);

QuillToolbar.propTypes = {
	onClickRaw: PropTypes.func,
};

export default QuillToolbar;
